"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionnaireLayoutSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 112, height: 77, viewBox: "0 0 112 77", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 14C14 12.8954 14.8954 12 16 12H97C98.1046 12 99 12.8954 99 14V20C99 21.1046 98.1046 22 97 22H16C14.8954 22 14 21.1046 14 20V14Z", fill: "#597EFF", fillOpacity: 0.1 }),
        react_1.default.createElement("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M21.3913 16H76.8261V18H21.3913V16Z", fill: "#597EFF" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 28C14 26.8954 14.8954 26 16 26H97C98.1046 26 99 26.8954 99 28V34C99 35.1046 98.1046 36 97 36H16C14.8954 36 14 35.1046 14 34V28Z", fill: "#597EFF", fillOpacity: 0.1 }),
        react_1.default.createElement("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M21.3913 30H76.8261V32H21.3913V30Z", fill: "#597EFF" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 42C14 40.8954 14.8954 40 16 40H97C98.1046 40 99 40.8954 99 42V64C99 65.1046 98.1046 66 97 66H16C14.8954 66 14 65.1046 14 64V42Z", fill: "#597EFF", fillOpacity: 0.1 }),
        react_1.default.createElement("path", { opacity: 0.4, fillRule: "evenodd", clipRule: "evenodd", d: "M21.3913 44H76.8261V46H21.3913V44Z", fill: "#597EFF" }));
}
function QuestionnaireLayout(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionnaireLayoutSvg, Object.assign({}, svgProps)));
}
exports.default = QuestionnaireLayout;
//# sourceMappingURL=QuestionnaireLayout.js.map